import { CartErrorMessage } from '@yme/common/redux/cart/constants';
import { PRODUCT_NAME_SEPARATOR, STOCK_SEPARATOR } from './constants';
export function getCartModalLabels(labels, commonLabels) {
    const { productCard_successAddToCartPopUpContinueShopping_button: continueShoppingLabel = '', productCard_successAddToCartPopUpGoToCart_button: goToCartLabel = '', productCard_successAddToCartPopUp_header: successTitleLabel = '', productCard_successAddToCartPopUp_message: successMessageLabel = '', productCard_outOfStockError_message: outOfStockErrorMessageLabel = '', productCard_incompatibleCartGroupError_message: cartGroupErrorMessageLabel = '', productCard_cartUpdateError_message: cartUpdateErrorMessageLabel = '', } = labels;
    const { common_popUpError_header: errorTitleLabel = '', common_popUpError_button: confirmButtonLabel = '', } = commonLabels;
    return {
        continueShoppingLabel,
        goToCartLabel,
        successTitleLabel,
        successMessageLabel,
        outOfStockErrorMessageLabel,
        cartGroupErrorMessageLabel,
        cartUpdateErrorMessageLabel,
        errorTitleLabel,
        confirmButtonLabel,
    };
}
export function getErrorMessage({ error, inCart }, productName, { outOfStockErrorMessageLabel, cartGroupErrorMessageLabel, cartUpdateErrorMessageLabel, }) {
    switch (error) {
        case CartErrorMessage.NO_STOCK_LEFT:
        case CartErrorMessage.NOT_ENOUGH_STOCK_LEFT:
            return outOfStockErrorMessageLabel
                .replace(PRODUCT_NAME_SEPARATOR, productName)
                .replace(STOCK_SEPARATOR, String(inCart));
        case CartErrorMessage.CART_GROUP_INCOMPATIBLE:
            return cartGroupErrorMessageLabel;
        default:
            return cartUpdateErrorMessageLabel;
    }
}
